export const SESSION_WORD_COUNT = 8;
export const STATE_READY = 0;
export const STATE_DONE = 1;
export const STATE_REDO = 2;
